export const PUBLIC_LISTING_ROUTE_PATTERNS = [
  '/renta',
  '/renta/:propertyType',
  '/renta/:propertyType/:propertySubtype',
  '/renta/:propertyType/:propertySubtype/:city',
  '/renta/:propertyType/:propertySubtype/:city/:municipality',
  '/renta/:propertyType/:propertySubtype/:city/:municipality/:colonia',
] as const;

export const LEGACY_PUBLIC_LISTING_ROUTE_PATTERNS = [
  '/propiedades',
] as const;

export const PUBLIC_PROPERTY_DETAIL_ROUTE_PATTERNS = [
  '/:tipo/:operacion/:city/:slug',
  '/:tipo/:operacion/:slug',
] as const;